// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-with-indicator {
  position: relative;
}
.text-with-indicator__dot-indicator {
  position: absolute;
  right: 0;
  transform: translateX(70%) translateY(-40%);
}
.text-with-indicator__dot-indicator--color-info.v-icon,
.text-with-indicator__dot-indicator--color-info.fa-dot.v-icon {
  color: var(--color-accent-content-base);
}
.text-with-indicator__dot-indicator--color-info.v-icon:hover,
.text-with-indicator__dot-indicator--color-info.fa-dot.v-icon:hover {
  color: var(--color-accent-content-base);
}
.text-with-indicator__dot-indicator--color-warning.v-icon,
.text-with-indicator__dot-indicator--color-warning.fa-dot.v-icon {
  color: var(--color-warning-content-base);
}
.text-with-indicator__dot-indicator--color-warning.v-icon:hover,
.text-with-indicator__dot-indicator--color-warning.fa-dot.v-icon:hover {
  color: var(--color-warning-content-base);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/text-with-indicator/TextWithIndicator.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,2CAAA;AACJ;AAEE;;EAEE,uCAAA;AAAJ;AAEI;;EACE,uCAAA;AACN;AAGE;;EAEE,wCAAA;AADJ;AAGI;;EACE,wCAAA;AAAN","sourcesContent":[".text-with-indicator {\n  position: relative;\n\n  &__dot-indicator {\n    position: absolute;\n    right: 0;\n    transform: translateX(70%) translateY(-40%);\n  }\n\n  &__dot-indicator--color-info.v-icon,\n  &__dot-indicator--color-info.fa-dot.v-icon {\n    color: var(--color-accent-content-base);\n\n    &:hover {\n      color: var(--color-accent-content-base);\n    }\n  }\n\n  &__dot-indicator--color-warning.v-icon,\n  &__dot-indicator--color-warning.fa-dot.v-icon {\n    color: var(--color-warning-content-base);\n\n    &:hover {\n      color: var(--color-warning-content-base);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
